<clr-modal [(clrModalOpen)]="showModal" (clrModalOpenChange)="!$event ? closeModal.emit() : null">
  <div class="modal-body">
    <iframe src="https://app.powerbi.com/reportEmbed?reportId=9450ac1d-594f-4d7d-8a7f-da28f89d100f&autoAuth=true&ctid=3e7ffad5-67c6-4cca-9d21-51e043f024dc&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtZXVyb3BlLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9" width="100%" height="100%" frameborder="0"></iframe>
  </div>
</clr-modal>
